import React, { useState } from "react";
import CryptoJS from "crypto-js";
import "bootstrap/dist/css/bootstrap.min.css";

const SymmetricEncryption = () => {
  const [text, setText] = useState("");
  const [aesKey, setAesKey] = useState(
    CryptoJS.lib.WordArray.random(32).toString()
  );
  const [encryptedAES, setEncryptedAES] = useState("");
  const [decryptedAES, setDecryptedAES] = useState("");

  const handleAESEncrypt = () => {
    const encrypted = CryptoJS.AES.encrypt(text, aesKey).toString();
    setEncryptedAES(encrypted);
  };

  const handleAESDecrypt = () => {
    const decrypted = CryptoJS.AES.decrypt(encryptedAES, aesKey).toString(
      CryptoJS.enc.Utf8
    );
    setDecryptedAES(decrypted);
  };

  return (
    <div className="container mt-5">
      <h4 className="mb-4">Symmetrische Verschlüsselung (AES)</h4>

      <div className="mb-3">
        <label htmlFor="text" className="form-label">
          Text zum Verschlüsseln:
        </label>
        <input
          type="text"
          className="form-control"
          id="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="aesKey" className="form-label">
          AES Schlüssel:
        </label>
        <input
          type="text"
          className="form-control"
          id="aesKey"
          value={aesKey}
          readOnly
        />
      </div>
      <button className="btn btn-primary me-2" onClick={handleAESEncrypt}>
        AES Verschlüsseln
      </button>
      <button className="btn btn-secondary" onClick={handleAESDecrypt}>
        AES Entschlüsseln
      </button>
      <div className="mt-2">
        <p>Verschlüsselter Text (AES): {encryptedAES}</p>
        <p>Entschlüsselter Text (AES): {decryptedAES}</p>
      </div>
    </div>
  );
};

export default SymmetricEncryption;
